import React from "react";
import {
  CustomDataTable
} from "../../../components/CommnTable/CustomDataTable";
import useFundViewExpense from "./useFundViewExpense"
import { FundViewExpense } from "../../../types/types";
import AddIcon from '@mui/icons-material/Add';
import {Card, Box, Typography, Chip, Button} from "@mui/material";
import styles from "../../ScholarshipApplication/ScholarshipApplicationDetails/ScholarshipApplicationDetails.module.scss";

const FundViewExpenses = () => {
    const {columns, userData, HandlePagination,data,fundDetail,limitValue, handleAddClick} = useFundViewExpense()
    return(  <Card
        style={{
          padding: "1rem",
          border: 0,
          boxShadow: "none",
          background: "none",
          
        }}
      >
        <Box className={"cardBoxUI cardBoxOtherUI"}>
          <Box className={styles.header} gap={2} alignItems={'center'} flexWrap={"wrap"}>
              <Box className={styles.navigationButtons}>
                  <Typography variant="h6">
                      Applicant Name
                  </Typography>
                 {<Chip className="ChipText" label={`${fundDetail?.name || userData.full_name} ${ fundDetail?.course ? `(${fundDetail.course})` : ''}`} color="info" sx={{ fontSize: 16 }} />}
              </Box>
              <Box className={styles.navigationButtons}>
                  <Typography variant="h6">
                      Scholarship ID
                  </Typography>
                 {<Chip label={fundDetail?.scholarship_id || userData.scholarship_name} color="success" sx={{ fontSize: 16 }} />}
              </Box>
          </Box>
          <CustomDataTable<FundViewExpense>
            data={data}
            columns={columns}
            tableTitle="Expense Summary"
            rowsPerPage={limitValue}
            HeaderComponent={<Button onClick={handleAddClick} variant="contained" color="success" sx={{borderRadius:2}}><AddIcon /> Add</Button>}
            onPageChange={(e: any) => HandlePagination(e)}
          />
        </Box>
      </Card>)
}

export default FundViewExpenses